import { COMEINPCIMAGE_URL } from '@/fetch/host';

export const MEETINGTYPE = {
	0: '待审批',
	1: '审核不通过',
	2: '已过期',
	3: '未开始',
	4: '进行中',
	5: '无人上麦',
	6: '已结束',
	9: '筹备中',
	10: '可回放',
	11: '审批通过'
};

export const CONFERENCE_STATUS_LATEST = {
	1: '筹备中',
	2: '待审批',
	3: '审批不通过',
	4: '审批通过',
	5: '待开始',
	6: '进行中',
	7: '已结束', // 路演、调研展示 已完成
	8: '可回放',
	9: '无人上麦',
	10: '无人入会',
	11: '已过期',
	12: '已删除',
	13: '已取消',
	14: '错误状态'
};

export const CONFERENCE_STATUS_LATEST_HK = {
	1: '籌備中',
	2: '待審批',
	3: '審批不通過',
	4: '審批通過',
	5: '待開始',
	6: '進行中',
	7: '已結束', //路演、調研展示已完成
	8: '可重播',
	9: '無人上麥',
	10: '無人入會',
	11: '已過期',
	12: '已删除',
	13: '已取消',
	14: '錯誤狀態'
};

export const CONFERENCE_STATUS_LATEST_EN = {
	1: 'Preparing',
	2: 'Under review',
	3: 'Disapproved',
	4: 'Approved',
	5: 'Upcoming',
	6: 'Live',
	7: 'Ended',
	8: 'Replayable',
	9: 'Still',
	10: 'Empty',
	11: 'Expired',
	12: 'Deleted',
	13: 'Cancelled',
	14: 'Error'
};

// irm活动页栏目
export const SORT_LIST_MAP = [
	{ title: '会议介绍', type: 0, id: 1001, name: 'conferenceDesc' },
	{ title: '会议嘉宾', type: 0, id: 1002, name: 'guests' },
	{ title: '会议流程', type: 0, id: 1003, name: 'processes' },
	{ title: '参会方式', type: 0, id: 1004, name: 'participationMethods' }
];

// 报名信息key
export const REGISTER_INFO = 'REGISTER_INFO';
export const USERTYPEID = 'USER_TYPE_ID';
export const BUSINESSCARD = 'BUSINESSCARD';
export const ENTOURAGE = 'ENTOURAGE';
export const ZOOM_REGISTER_INFO = 'ZOOM_REGISTER_INFO';
export const ZOOM_REGISTER_TOKENS = 'ZOOM_REGISTER_TOKENS';

// 游客报名填写的信息
export const AUTO_LOGIN_USER_INFO = 'autoLoginUserInfo';
// 游客报名成功后，保存的token信息
export const TOURIST_INFO = 'touristInfo';

export const ECHARTS_COLORS = [
	'#3964E5',
	'#73DCFF',
	'#9673FF',
	'#FF7373',
	'#FF9673',
	'#FFB973',
	'#FFDC73',
	'#E5E567',
	'#C6E567',
	'#67E587',
	'#67E6B1',
	'#67E6DB',
	'#67C6E6',
	'#679CE6',
	'#6772E6',
	'#8767E6',
	'#B167E6',
	'#DB67E6',
	'#E667C6',
	'#E6679C',
	'#E66772'
];

const IR_COLOR_PALETTE = {
	'#3964e5': {
		'gradients-charts': ['#3964e5', '#73DCFF', '#9673FF', '#FF7373'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#3964E5'
	},
	'#F23D3D': {
		'gradients-charts': ['#F23D3D', '#F26A3D', '#FFDC73', '#C6E567'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#FF7373'
	},
	'#ad053d': {
		'gradients-charts': ['#ad053d', '#F26A3D', '#FFDC73', '#C6E567'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#FF7373'
	},
	'#f26a3d': {
		'gradients-charts': ['#f26a3d', '#FFB973', '#FFDC73', '#C6E567'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#FF9673'
	},
	'#8539e6': {
		'gradients-charts': ['#8539e6', '#FF7373', '#FFB973', '#E5E567'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#9673FF'
	},
	'#30bf54': {
		'gradients-charts': ['#30bf54', '#C6E567', '#FFB973', '#FF7373'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#EBFBEF'
	},
	'#1D2129': {
		'gradients-charts': ['#1D2129', '#73DCFF', '#9673FF', '#FF7373'],
		'gradients': ['#1D2129', '#1D2129'], // 黑色没有色相效果 改为纯色展示
		'fade': '#3964E5'
	},
	'#D2A36C': {
		'gradients-charts': ['#D2A36C', '#73DCFF', '#9673FF', '#FF7373'],
		'gradients': ['#2060C0', '#81A1FF'],
		'fade': '#3964E5'
	}
};

function generateColorMap(callback) {
	const map = {};
	Object.keys(IR_COLOR_PALETTE).forEach(key => {
		map[key.toUpperCase()] = callback(IR_COLOR_PALETTE[key], key);
	});
	return map;
}

export const IR_THEME_DEFAULT = '#3964E5';
export const IR_ECHARTS_COLORS = generateColorMap(item => item['gradients-charts']);
export const IR_GRADIENT_THEME_MAP = generateColorMap(item => item['gradients']);
export const IR_FADE_COLORS = generateColorMap(item => item['fade']);

export const GRAPHIC_THEME_CONFIG = {
	'#1E379E': {
		type: 1,
		bgColor: '#B6D7FD',
		histogram: { blockColor: 'rgba(30, 55, 158, 0.6)', lineColor: 'rgba(30, 55, 158, 0.3)' },
		fan_chart: {
			color: [
				'#1E379E',
				'#73DCFF',
				'#9673FF',
				'#FF7373',
				'#FF9673',
				'#5470C6',
				'#91CC76',
				'#FAC858',
				'#73C0DE',
				'#FC8452'
			],
			numColor: '#1E379E',
			rateColor: '#F23D3D',
			labelBg: 'rgba(30,55,158,0.03)',
			lineColor: 'rgba(30,55,158,0.3)'
		},
		data_indicators: {
			blockColor: 'rgba(30, 55, 158, 0.1)',
			itemColor: 'rgba(30, 55, 158, 0.03)',
			lineColor: 'rgba(30, 55, 158, 0.3)'
		},
		top_ten_shareholders: {
			progressBg: 'linear-gradient(90.00deg, rgba(30, 55, 158, 0.4),rgb(30, 55, 158) 100%)'
		}
	},
	'#C8000A': {
		type: 2,
		bgColor: '#dedede',
		histogram: { blockColor: 'rgba(200, 0, 10, 0.5)', lineColor: '#EBEBEB' },
		fan_chart: {
			color: [
				'#C8000A',
				'#FF5B58',
				'#7A7A7A',
				'#9B9B9B',
				'#D0D1D1',
				'#DCDCDC',
				'#E3E3E3',
				'#F2F2F2',
				'#F4F4F4',
				'rgba(244, 244, 244, 0.6)'
			],
			numColor: '#291D1D',
			rateColor: '#C8000A',
			labelBg: 'rgba(200,0,10,0.03)',
			lineColor: 'rgba(30,55,158,0.3)'
		},
		data_indicators: {
			blockColor: 'rgba(200, 0, 10, 0.1)',
			itemColor: 'rgba(200, 0, 10, 0.03)',
			lineColor: '#EBEBEB'
		},
		top_ten_shareholders: {
			progressBg: 'linear-gradient(90.00deg, rgba(203, 41, 41, 0.4),rgb(200, 0, 10) 100%)'
		}
	}
};

export const signTypeStr = {
	1: '多人签',
	2: '单人签',
	3: '汇总签',
	4: '表决签'
};
export const CONFERENCE_TYPE = {
	1: '线上会议',
	2: '线下会议',
	3: '导入会议',
	4: '快速线上会议',
	5: '快速线下会议'
};
// 匹配的默认图片地址
export const DEFAULTPOSTERIMAGE = {
	'2:1': '/default/default_meeting_cover21.png',
	'16:9': '/default/default_poster169.png',
	'4:3': '/default/default_poster43.png'
};

/** 新版路演/调研封面默认缺省图 */
export const DEFAULT_POSTER_IMAGE_V2 = {
	roadshow21: COMEINPCIMAGE_URL + '/irm/default/default_roadshow_poster21.png',
	roadshow169: COMEINPCIMAGE_URL + '/irm/default/default_roadshow_poster169.png',
	roadshow43: COMEINPCIMAGE_URL + '/irm/default/default_roadshow_poster43.png',
	surver21: COMEINPCIMAGE_URL + '/irm/default/default_surver_poster21.png',
	surver169: COMEINPCIMAGE_URL + '/irm/default/default_surver_poster169.png',
	surver43: COMEINPCIMAGE_URL + '/irm/default/default_surver_poster43.png',
	roadshowV2: COMEINPCIMAGE_URL + '/irm/default/default_roadshow_v2.png',
	surverV2: COMEINPCIMAGE_URL + '/irm/default/default_surver_v2.png'
};

// 基本报名信息默认值
export const BASE_INFO_DEFAULT = [
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 0,
		source: 1,
		type: 0,
		conditionName: '姓名',
		zhConditionName: '姓名'
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 1,
		source: 1,
		type: 0,
		conditionName: '公司',
		zhConditionName: '公司',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 2,
		source: 1,
		type: 0,
		conditionName: '职位',
		zhConditionName: '职位',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 3,
		source: 1,
		type: 0,
		conditionName: '参会号码',
		zhConditionName: '参会号码',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 0,
		isShow: 1,
		sort: 4,
		source: 1,
		type: 0,
		conditionName: '电子邮箱',
		zhConditionName: '电子邮箱',
		value: ''
	}
];

export const BASE_INFO_DEFAULT_IN_ZOOM = [
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 0,
		source: 1,
		type: 0,
		conditionName: '姓名',
		zhConditionName: '姓名'
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 1,
		source: 1,
		type: 0,
		conditionName: '公司',
		zhConditionName: '公司',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 2,
		source: 1,
		type: 0,
		conditionName: '职位',
		zhConditionName: '职位',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 0,
		isShow: 1,
		sort: 3,
		source: 1,
		type: 0,
		conditionName: '参会号码',
		zhConditionName: '参会号码',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 4,
		source: 1,
		type: 0,
		conditionName: '电子邮箱',
		zhConditionName: '电子邮箱',
		value: ''
	}
];

// 基本报名信息默认值
export const BASE_INFO_DEFAULT_1 = [
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 0,
		source: 1,
		type: 0,
		conditionName: '姓名'
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 0,
		isShow: 1,
		sort: 1,
		source: 1,
		type: 0,
		conditionName: '公司',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 0,
		isShow: 1,
		sort: 2,
		source: 1,
		type: 0,
		conditionName: '职位',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 1,
		isShow: 1,
		sort: 3,
		source: 1,
		type: 0,
		conditionName: '参会号码',
		value: ''
	},
	{
		conditionOptionsValid: false,
		customerType: 0,
		defaultValueValid: false,
		isRequired: 0,
		isShow: 1,
		sort: 4,
		source: 1,
		type: 0,
		conditionName: '电子邮箱',
		value: ''
	}
];

/**
 * 免登录模式自定义信息配置问题
 */
export const registerBaseInrfo = [
	{
		conditionName: '姓名',
		type: 0, //  0 为 输入框
		isShow: 1,
		isRequired: 1,
		allowEdit: 1,
		source: 1
	},
	{
		conditionName: '公司',
		type: 0,
		isShow: 1,
		isRequired: 1,
		allowEdit: 1,
		source: 1
	},
	{
		conditionName: '所属部门',
		type: 0,
		isShow: 1,
		isRequired: 0,
		allowEdit: 1,
		source: 1
	},
	{
		conditionName: '职位',
		type: 0,
		isShow: 1,
		isRequired: 0,
		allowEdit: 1,
		source: 1
	},
	{
		conditionName: '参会号码',
		type: 0,
		isShow: 1,
		isRequired: 0,
		allowEdit: 1,
		source: 1
	},
	{
		conditionName: '电子邮箱',
		type: 0,
		isShow: 1,
		isRequired: 0,
		allowEdit: 1,
		source: 1
	}
];

// 常见复姓
export const DOUBLE_SURNAME = [
	'欧阳',
	'太史',
	'端木',
	'上官',
	'司马',
	'东方',
	'独孤',
	'南宫',
	'万俟',
	'闻人',
	'夏侯',
	'诸葛',
	'尉迟',
	'公羊',
	'赫连',
	'澹台',
	'皇甫',
	'宗政',
	'濮阳',
	'公冶',
	'太叔',
	'申屠',
	'公孙',
	'慕容',
	'仲孙',
	'钟离',
	'长孙',
	'宇文',
	'司徒',
	'鲜于',
	'司空',
	'闾丘',
	'子车',
	'亓官',
	'司寇',
	'巫马',
	'公西',
	'颛孙',
	'壤驷',
	'公良',
	'漆雕',
	'乐正',
	'宰父',
	'谷梁',
	'拓跋',
	'夹谷',
	'轩辕',
	'令狐',
	'段干',
	'百里',
	'呼延',
	'东郭',
	'南门',
	'羊舌',
	'微生',
	'公户',
	'公玉',
	'公仪',
	'梁丘',
	'公仲',
	'公上',
	'公门',
	'公山',
	'公坚',
	'左丘',
	'公伯',
	'西门',
	'公祖',
	'第五',
	'公乘',
	'贯丘',
	'公皙',
	'南荣',
	'东里',
	'东宫',
	'仲长',
	'子书',
	'子桑',
	'即墨',
	'达奚',
	'褚师'
];

// 营销页内容组件对应的typeID
export const TYPE_ENUM = {
	1: 'TITLE',
	2: 'TIME',
	3: 'INFO',
	4: 'DESC',
	5: 'GUEST',
	6: 'PROCESS',
	7: 'PARTICIPATION',
	8: 'RELATED_CONFERENCE',
	9: 'ADDRESS',
	10: 'ORGANIZER_DESC',
	11: 'ASSISTING_AGENCY',
	12: 'ATTEND_MANAGER',
	13: 'RECEPTIONIST',
	15: 'COMPANY_ANNOUNCEMENT',
	16: 'NEWS_MODULE',
	17: 'CAROUSEL',
	18: 'GUEST'



};

/**
 * 营销页自定义组件类型
 * 内容类型:0-默认，1-自定义按钮，2-富文本模块,3-图文模块，4-图片轮播，5-视频模块,6-页面跳转模块
 */
export const CUSTOM_TYPE_ENUM = {
	2: 'RICH_TEXT',
	// 3: 'IMAGE_TEXT',
	// 3: 'NEWS_MODULE',
	3: 'IMAGE_TEXT',
	4: 'CAROUSEL',
	5: 'VIDEO',
	6: 'LINK'
};

export const WEEKS_CN = {
	0: '周日',
	1: '周一',
	2: '周二',
	3: '周三',
	4: '周四',
	5: '周五',
	6: '周六'
};

export const WEEKS_HK = {
	0: '週日',
	1: '週一',
	2: '週二',
	3: '週三',
	4: '週四',
	5: '週五',
	6: '週六'
};

export const WEEKS_EN = {
	0: 'Sun',
	1: 'Mon',
	2: 'Tue',
	3: 'Wed',
	4: 'Thu',
	5: 'Fri',
	6: 'Sat'
};

export const BASIC_CONDITION_ENUM = {
	0: 'userName',
	1: 'firstName',
	2: 'lastName',
	3: 'companyName',
	4: 'department',
	5: 'occupation',
	6: 'phoneNumber',
	7: 'email',
	8: 'preQuestion',
	9: 'businessCard'
};
// 0-填写，1-单选，2-多选，3-图片，4-问卷链接，5.文件
export const CUSTOM_CONDITION_ENUM = {
	0: 'input',
	1: 'radio',
	2: 'checkbox',
	3: 'image',
	4: 'link',
	5: 'file'
};
